import swipeDetector from '@ts/utils/swipe-detector';

export default function Plugin(Alpine) {
    Alpine.directive('swipe', (elem, { value, modifiers, expression }, { evaluateLater, cleanup }) => {
        const evaluate = expression ? evaluateLater(expression) : () => {};
        const callback = (arg) => {
            evaluate(() => {}, { scope: {}, params: [arg] });
        };
        const threshold = (modifiers[0] === 'threshold' && (modifiers[1] || '').endsWith('px') && Number(modifiers[1].replace('px', ''))) || 50;
        const detectorInstance = swipeDetector(
            elem,
            function (direction) {
                if (!value) {
                    callback(direction);
                    return;
                }
                if (direction === value) {
                    callback(direction);
                }
            },
            threshold
        );

        cleanup(() => {
            detectorInstance.disable();
        });
    });
}
